import { Types } from "../actions/layoutActions";

const initialState = {
    snackMessage: undefined,
};

export const layoutReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SHOW_SNACK_MESSAGE:
            return {
                ...state,
                snackMessage: action.payload || state.snackMessage,
            };
        case Types.SET_SNACK_MESSAGE:
            return {
                ...state,
                snackMessage: undefined,
            };

        //
        default:
            return state;
    }
};
